// Helper function to transpose chords
export const transposeChord = (chord: string, semitones: number): string => {
  const notes = ['C', 'C#', 'D', 'D#', 'E', 'F', 'F#', 'G', 'G#', 'A', 'A#', 'B'];
  const chordRegex = /^([A-G][#b]?)(.*)/;
  
  const match = chord.match(chordRegex);
  if (!match) return chord;
  
  const [, rootNote, suffix] = match;
  let noteIndex = notes.indexOf(rootNote);
  
  // Handle flat notes
  if (rootNote.includes('b')) {
    const flatMap: { [key: string]: number } = {
      'Db': 1, 'Eb': 3, 'Gb': 6, 'Ab': 8, 'Bb': 10
    };
    noteIndex = flatMap[rootNote] || noteIndex;
  }
  
  if (noteIndex === -1) return chord;
  
  const newNoteIndex = (noteIndex + semitones + 12) % 12;
  return notes[newNoteIndex] + suffix;
};

// Helper function to transpose ChordPro content
export const transposeChordProContent = (content: string, semitones: number): string => {
  const chordRegex = /\[([A-G][#b]?[^\]]*)\]/g;
  
  return content.replace(chordRegex, (match, chord) => {
    const transposedChord = transposeChord(chord, semitones);
    return `[${transposedChord}]`;
  });
};

// Get the new key after transposition
export const getTransposedKey = (originalKey: string, semitones: number): string => {
  return transposeChord(originalKey, semitones);
};